import React from "react";
import { safeUrl } from "./helpers";

export default function SocialLinks({ links }) {
  const facebook = safeUrl(links?.facebook);
  const instagram = safeUrl(links?.instagram);
  const polarsteps = safeUrl(links?.polarsteps);

  if (!facebook && !instagram && !polarsteps) {
    return <span className="tw-muted">Aucun lien renseigné</span>;
  }

  return (
    <>
      {facebook && (
        <a className="tw-chip" href={facebook} target="_blank" rel="noreferrer">
          Facebook
        </a>
      )}
      {instagram && (
        <a className="tw-chip" href={instagram} target="_blank" rel="noreferrer">
          Instagram
        </a>
      )}
      {polarsteps && (
        <a className="tw-chip" href={polarsteps} target="_blank" rel="noreferrer">
          Polarsteps
        </a>
      )}
    </>
  );
}
